import React from 'react'
import PropTypes from 'prop-types'
import {
  ReportsItem,
  ReportsItemIcon,
  ReportsMain,
  ReportLink,
} from './index.style'
import RichText from '@components/RichText'
import Spacer from '@components/Spacer'
import { Caption } from '@components/TextStyles'
import IconArrowRight from '@svgs/IconArrowRight'

const Reports = ({ content }) => {
  return (
    <ReportsMain>
      {React.Children.toArray(
        content.map((report, reportIndex) => (
          <ReportsItem>
            {reportIndex === 0 ? (
              <Spacer size={[20, 40]} />
            ) : (
              <Spacer size={[40, 80]} />
            )}

            <Caption>{report.date}</Caption>

            <Spacer size={[40, 73]} />

            <ReportLink
              href={report.pdfDownload.file.url}
              download
              target="_blank"
            >
              <RichText
                content={report.formattedTitle}
                paragraphSize="heading3Serif"
                as="h3"
              />
            </ReportLink>

            <Spacer size={[20, 40]} />

            <ReportsItemIcon>
              <IconArrowRight />
            </ReportsItemIcon>
          </ReportsItem>
        ))
      )}

      <Spacer size={[40, 80]} />
    </ReportsMain>
  )
}

Reports.propTypes = {
  content: PropTypes.array,
}

export default Reports
